/**
 * Database Initialisatie
 * Start de hele boel op, fingers crossed
 */

import {databaseClient} from './index';
import {maakApplicatieFout, isApplicatieFout} from '../models/AppError';
import {
  initializeDatabaseOnFirstLaunch,
  checkForDatabaseUpdates,
} from './dataLoader';

/**
 * Database initialiseren (hopelijk zonder errors)
 * Eén keer aanroepen aub
 */
export async function initializeDatabase(): Promise<void> {
  try {
    // Connectie maken
    // Dit opent de SQLite db of de lokale web db
    await databaseClient.initialize();
    
    // Web: Data laden als het de eerste keer is.
    // Dit pompt die grote JSON file in je lokale opslag.
    await initializeDatabaseOnFirstLaunch();
    
    // Web: Updates checken (lekker op de achtergrond)
    checkForDatabaseUpdates().catch(error => {
      console.warn('Database update check mislukt:', error);
      // Niet crashen, updates boeien nu even niet
    });
  } catch (error) {
    console.error('Database initialisatie fout:', error);
    
    // Als het al een AppError is, gewoon doorgooien
    if (isApplicatieFout(error)) {
      throw error;
    }
    
    // Anders inpakken als AppError
    // Zodat de UI weet wat ie moet zeggen
    throw maakApplicatieFout(
      'database_init',
      `Database initialisatie mislukt: ${error instanceof Error ? error.message : 'Onbekende fout'}`,
      true,
      () => initializeDatabase(),
      error instanceof Error ? error : undefined,
    );
  }
}


